import { type I18n, i18nFormat } from "@common/lib/i18n";
import { type MessageType } from "./Modal";
import { type OtpContextApi, type OtpContextStartApi, type OtpLinkContextStartApi } from "./types";

export const isLinkOtp = (modal: OtpContextApi | null): modal is OtpLinkContextStartApi => {
  return modal !== null && "sendLink" in modal;
};

export const isStandardOtp = (modal: OtpContextApi | null): modal is OtpContextStartApi => {
  return modal !== null && "sendCode" in modal;
};

export const getLocalization = (
  i18n: I18n,
  type: "optionLabel" | "sentInfo" | "sendInfo",
  messageType: MessageType,
  destination: string,
  userName?: string,
  isLink?: boolean
): string => {
  switch (type) {
    case "optionLabel": {
      switch (messageType) {
        case "Email": {
          return i18nFormat(isLink ? i18n.infoOTLSendOptionEmail : i18n.infoOTPSendOptionEmail, ["EMAIL", destination]);
        }
        case "Text": {
          return i18nFormat(isLink ? i18n.infoOTLSendOptionSMS : i18n.infoOTPSendOptionSMS, ["PHONE", destination]);
        }
        case "WhatsApp": {
          return i18nFormat(isLink ? i18n.infoOTLSendOptionWhatsApp : i18n.infoOTPSendOptionWhatsApp, [
            "PHONE",
            destination
          ]);
        }
      }
    }
    case "sendInfo": {
      switch (messageType) {
        case "Email": {
          return i18nFormat(isLink ? i18n.infoOTLSendEmail : i18n.infoOTPSendEmail, ["EMAIL", destination]);
        }
        case "Text": {
          return i18nFormat(isLink ? i18n.infoOTLSendSMS : i18n.infoOTPSendSMS, ["PHONE", destination]);
        }
        case "WhatsApp": {
          return i18nFormat(isLink ? i18n.infoOTLSendWhatsApp : i18n.infoOTPSendWhatsApp, ["PHONE", destination]);
        }
      }
    }
    case "sentInfo": {
      switch (messageType) {
        case "Email": {
          return i18nFormat(
            isLink ? i18n.infoOTLSentEmail : i18n.infoOTPSentEmail,
            ["EMAIL", destination],
            ["USER", userName]
          );
        }
        case "Text": {
          return i18nFormat(
            isLink ? i18n.infoOTLSentSMS : i18n.infoOTPSentSMS,
            ["PHONE", destination],
            ["USER", userName]
          );
        }
        case "WhatsApp": {
          return i18nFormat(
            isLink ? i18n.infoOTLSentWhatsApp : i18n.infoOTPSentWhatsApp,
            ["PHONE", destination],
            ["USER", userName]
          );
        }
      }
    }
  }
};
